import { render, staticRenderFns } from "./show-info.vue?vue&type=template&id=a151b8bc&scoped=true&"
import script from "./show-info.vue?vue&type=script&lang=js&"
export * from "./show-info.vue?vue&type=script&lang=js&"
import style0 from "./show-info.vue?vue&type=style&index=0&id=a151b8bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a151b8bc",
  null
  
)

export default component.exports